import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`
const customerJavaApi = `${config.apiHost}/oem-customer-java`

export default {
    tags: {
        url: `${customerApi}/api/tags`,
        type: 'GET',
    },
    memberInfo: {
        url: `${customerJavaApi}/api/customer/member/info`,
        type: 'GET',
    },
}
